module.exports = __webpack_public_path__ + "static/media/ios-app-icon.c36c3613.png";